// this i18n is called from main when init i18n module
import { i18n as i18nbis } from "../../main.js";
import cacheService from "@/services/cache";

export const i18n = {
    namespaced: true,
    state: {
        langs: [],
        locale: "" // @ todo find how init value lang default
    },
    getters: {
        i18n: state => {
            return state.i18n;
        },
        getLocale(state) {
            if (!state.locale) {
                state.locale = cacheService.getUserLang();
            }
            return state.locale;
        },
        getLangs(state) {
            return state.langs;
        }
    },
    mutations: {
        SET_LOCALE(state, value) {
            let valueLang = value.split(",");
            state.locale = valueLang[1];
            i18nbis.locale = valueLang[1]; // state created with Vuei18n in main.js
            cacheService.set("userLangId", valueLang[0]);
        },
        SET_LANGS(state, value) {
            state.langs = value;
        }
    },
    actions: {
        setLocale(context, locale) {
            context.commit("SET_LOCALE", locale);
        },
        setLangs(context, langs) {
            context.commit("SET_LANGS", langs);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/i18n/i18n.js